// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"05e6686f","132":"548d4c96","229":"c04fd5cd","631":"3b30c543","731":"d4349ab5","977":"5fe9b547"}[chunkId] + ".css";
};